import BoxHeart from '@/app/refund-methods/v1/box-heart'
import { useTranslate } from '@/hooks'
import ExchangeIcon from '@/app/refund-methods/v1/exchange-icon'
import { useAppDispatch } from '@/redux/hooks'
import { resetReturnMethod, setKeepYourItem } from '@/redux/return/return-slice'
import { useEffect, useState } from 'react'

interface ExchangeKYICardsProps {
  isKYIForced: boolean
}

export const ExchangeKYICards: React.FC<ExchangeKYICardsProps> = ({
  isKYIForced
}) => {
  const dispatch = useAppDispatch()
  const { translate } = useTranslate()

  const [kyiSelected, setKyiSelected] = useState(true)

  useEffect(() => {
    dispatch(setKeepYourItem(kyiSelected))
    dispatch(resetReturnMethod())
  }, [kyiSelected])

  return (
    <>
      <div
        className="relative flex content-center items-center"
        onClick={() => {
          setKyiSelected(true)
        }}
      >
        <div
          className="mb-6 w-full cursor-pointer rounded-sm"
          style={{
            padding: kyiSelected ? '12px 10px' : '14px 12px',
            borderWidth: kyiSelected ? '2px' : '0px',
            borderColor: kyiSelected ? '#1b75eb' : undefined,
            backgroundColor: kyiSelected
              ? 'rgba(27, 117, 235, 0.1)'
              : undefined,
            boxShadow: kyiSelected
              ? undefined
              : '0px 0px 2px 2px rgba(0,0,0,0.1)'
          }}
        >
          <div className="flex items-center justify-between gap-2">
            <div className="flex items-center gap-2">
              <div className="opacity-60">
                <BoxHeart />
              </div>
              <p className="text-lg">
                <b>{translate(`kyi_title`)}</b>
              </p>
            </div>
          </div>
          <div>
            <p
              className="text-xs"
              dangerouslySetInnerHTML={{
                __html: translate(
                  'kyi_refund_page_only_exchanges_keep_description'
                )
              }}
            />
          </div>
        </div>
      </div>
      {!isKYIForced && (
        <div
          className="relative flex content-center items-center"
          onClick={() => {
            setKyiSelected(false)
          }}
        >
          <div
            className="mb-6 w-full cursor-pointer rounded-sm"
            style={{
              padding: !kyiSelected ? '12px 10px' : '14px 12px',
              borderWidth: !kyiSelected ? '2px' : '0px',
              borderColor: !kyiSelected ? '#1b75eb' : undefined,
              backgroundColor: !kyiSelected
                ? 'rgba(27, 117, 235, 0.1)'
                : undefined,
              boxShadow: !kyiSelected
                ? undefined
                : '0px 0px 2px 2px rgba(0,0,0,0.1)'
            }}
          >
            <div className="flex items-center justify-between gap-2">
              <div className="flex items-center gap-1">
                <div className="size-8 opacity-60">
                  <ExchangeIcon />
                </div>
                <p className="text-lg">
                  <b
                    dangerouslySetInnerHTML={{
                      __html: translate(
                        'kyi_refund_page_only_exchanges_return_title'
                      )
                    }}
                  />
                </p>
              </div>
            </div>
            <div>
              <p
                className="text-xs"
                dangerouslySetInnerHTML={{
                  __html: translate(
                    'kyi_refund_page_only_exchanges_return_description'
                  )
                }}
              />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default ExchangeKYICards
